export default "__VITE_ASSET__npFvOawC__"